import { el } from "../util";

export function openModal(title: string, body: HTMLElement, actions: { label: string; primary?: boolean; onClick: () => void | boolean }[] = []): () => void {
  const bg = el("div", { class: "modal-bg" });
  const modal = el("div", { class: "modal" });
  modal.append(el("h3", { text: title }), body);
  const act = el("div", { class: "actions" });
  const close = () => bg.remove();
  for (const a of actions) {
    const b = el("button", { class: a.primary ? "active" : "", text: a.label });
    b.addEventListener("click", () => { if (a.onClick() !== false) close(); });
    act.append(b);
  }
  if (actions.length) modal.append(act);
  bg.append(modal);
  bg.addEventListener("mousedown", (e) => { if (e.target === bg) close(); });
  document.body.append(bg);
  return close;
}

export function openContextMenu(x: number, y: number, items: { label: string; onClick: () => void; disabled?: boolean }[]) {
  document.querySelector(".ctx-menu")?.remove();
  const menu = el("div", { class: "ctx-menu" });
  for (const it of items) {
    const b = el("button", { text: it.label });
    if (it.disabled) b.setAttribute("disabled", "true");
    b.addEventListener("click", () => { menu.remove(); it.onClick(); });
    menu.append(b);
  }
  menu.style.left = x + "px";
  menu.style.top = y + "px";
  document.body.append(menu);
  const close = (e: MouseEvent) => { if (!menu.contains(e.target as Node)) { menu.remove(); window.removeEventListener("mousedown", close); } };
  setTimeout(() => window.addEventListener("mousedown", close), 0);
}

let toastTimer: any;
export function toast(msg: string, ms = 2400) {
  document.querySelector(".toast")?.remove();
  const t = el("div", { class: "toast", text: msg });
  document.body.append(t);
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.remove(), ms);
}
